import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import SvgIcon from "@mui/material/SvgIcon";
import SearchMdIcon from "@untitled-ui/icons-react/build/esm/SearchMd";
import ChevronDownIcon from "@untitled-ui/icons-react/build/esm/ChevronDown";
import { SearchDialog } from "./search-dialog";
import type { FC } from "react";
import { useFileSettings } from "~/hooks/use-file-settings";
import { InputAdornment, OutlinedInput } from "@mui/material";
export const SearchButton: FC = () => {
  const {
    fileSearch,
    handleUpdateSearch,
    handleClearSearch,
    handleFileSearchOpen,
    handleFileSearchClose
  } = useFileSettings();
  return <>
			<Box data-sentry-element="Box" data-sentry-source-file="search-button.tsx">
				<Stack alignItems="center" direction="row" spacing={1} data-sentry-element="Stack" data-sentry-source-file="search-button.tsx">
					<OutlinedInput value={fileSearch?.files?.join(",") ?? ""} fullWidth placeholder="Search order #" onChange={e => {
          const value = e.target.value ?? "";
          const update = {
            field: "files",
            search: value.trim().split(",")
          };
          void handleUpdateSearch(update);
        }} startAdornment={<InputAdornment position="start">
								<SvgIcon>
									<SearchMdIcon />
								</SvgIcon>
							</InputAdornment>} endAdornment={<InputAdornment position="end">
								<Box sx={{
            backgroundColor: theme => theme.palette.mode === "dark" ? "neutral.800" : "neutral.100",
            borderLeft: "1px solid",
            borderColor: "action",
            borderRadius: "0 6px 6px 0",
            m: -1.8
          }}>
									<Stack alignItems="center" direction="row" onClick={handleFileSearchOpen} sx={{
              cursor: "pointer",
              py: 1.8,
              px: 3,
              userSelect: "none"
            }}>
										<SvgIcon color="action">
											<ChevronDownIcon />
										</SvgIcon>
									</Stack>
								</Box>
							</InputAdornment>} data-sentry-element="OutlinedInput" data-sentry-source-file="search-button.tsx" />
				</Stack>
			</Box>

			{fileSearch?.isModelOpen && <SearchDialog search={fileSearch} updateSearch={handleUpdateSearch} clearSearch={handleClearSearch} onClose={handleFileSearchClose} />}
		</>;
};